<style lang="scss" scoped>
.contentbg-wrapper{
  width: 100%;
  height: 657px;
  // background: url('./../assets/img/bg-pc.svg') no-repeat;
  // background-size: contain;
  // background-origin: center;
  // background-position:50% 50%;
}
</style>

<template>
 <img class="contentbg-wrapper" :src="imgUrl" alt="">
</template>

<script>
export default {
  data() {
    return {
      imgUrl: ''
    }
  },
  mounted() {
    this.$bus.on('indexBgData', (res) => {
      this.imgUrl = res.cover;
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/blocks/ContentBg.vue